<template lang="html">
  <section class="comp-ctn-docs">
  	Documents Privés
		<div class="ctn-docs row">
			<tile-doc :doc="doc" v-for="(doc, key) in docs" v-bind:key="key" />
		</div>
  </section>
</template>

<script>
import TileDoc from '@/common/components/tile-doc'
export default {
	components: {
		TileDoc
	},
	data () {
		return {
			docs: null
		}
	},
	methods: {
		fetchDocs () {
			console.log('no need')
		}
	},
	mounted () {
		this.docs = this.$store.getters.typeDocuments('private')
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// PrivateDocs.vue?530b7ef0